module.exports = __webpack_public_path__ + "static/img/ent-73.d9cbb76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-73.jpg
// module id = GwKx
// module chunks = 52